import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FiSettings } from "react-icons/fi";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { useSelector } from "react-redux";
import { Navbar, Footer, Sidebar, ThemeSettings } from "./components";
import { Ecommerce } from "./pages";

import LoginPage from "./pages/login/page";
import KycVerifiedPage from "./pages/kyc-verified/page";
import AllUsersPage from "./pages/allusers/page";
import RiskProfilePage from "./pages/riskprofile/page";
import OrderbookPage from "./pages/orderbook/page";
import SubscriptionPage from "./pages/subscription/page";

import "./App.css";
import { useStateContext } from "./contexts/ContextProvider";

const App = () => {
  const {
    currentMode,
    activeMenu,
    currentColor,
    themeSettings,
    setThemeSettings,
  } = useStateContext();

  const { isAuthenticated } = useSelector((state) => state.auth);

  const handleSignIn = () => {};

  // If not logged in, show login page
  if (!isAuthenticated) {
    return <LoginPage onSignIn={handleSignIn} />;
  }

  return (
    <div className={`${currentMode === "Dark" ? "dark" : ""}`}>
      <BrowserRouter>
        <div className="flex dark:bg-main-dark-bg overflow-x-hidden">
          {/* Floating Settings Button */}
          <div className="fixed right-4 bottom-4 z-[1000]">
            <TooltipComponent content="Settings" position="Top">
              <button
                type="button"
                onClick={() => setThemeSettings(true)}
                style={{ background: currentColor, borderRadius: "50%" }}
                className="text-3xl text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
              >
                <FiSettings />
              </button>
            </TooltipComponent>
          </div>

          {/* Sidebar */}
          {activeMenu ? (
            <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white">
              <Sidebar />
            </div>
          ) : (
            <div className="w-0 dark:bg-secondary-dark-bg">
              <Sidebar />
            </div>
          )}

          {/* Main Content */}
          <div
            className={`${
              activeMenu
                ? "dark:bg-main-dark-bg bg-main-bg min-h-screen md:ml-72 w-full"
                : "bg-main-bg dark:bg-main-dark-bg w-full min-h-screen flex-2"
            } overflow-x-hidden`}
          >
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full">
              <Navbar />
            </div>

            {/* Theme Settings Modal */}
            {themeSettings && <ThemeSettings />}

            {/* Routes */}
            <Routes>
              {/* Dashboard */}
              <Route path="/" element={<Ecommerce />} />
              <Route path="/home" element={<Ecommerce />} />

              {/* Pages */}
              <Route path="/kyc-verified" element={<KycVerifiedPage />} />
              <Route path="/allusers" element={<AllUsersPage />} />
              <Route path="/riskprofile" element={<RiskProfilePage />} />
              <Route path="/orderbook" element={<OrderbookPage />} />
              <Route path="/subscription" element={<SubscriptionPage />} />
            </Routes>

            {/* Footer */}
            <Footer />
          </div>
        </div>
      </BrowserRouter>
    </div>
  );
};

export default App;
